module.exports = __webpack_public_path__ + "media/icons/punctual-82c17b01.svg";